module.exports = __webpack_public_path__ + "static/Ghost-75a187e9b10a83b30b16799701079642.jpg";